/** 图片空间展示 URL：优先受管 canonical，入库失败时回退 dataUrl（非受管，可本机预览） */

function trimmed(value) {
  return typeof value === 'string' ? value.trim() : '';
}

export function isInlineImagePreviewUrl(url) {
  const s = trimmed(url);
  return s.startsWith('data:') || s.startsWith('blob:');
}

/** 条目是否已有持久化受管地址（/uploads/ 或 OSS https） */
export function hasImageSpacePersistedUrl(image) {
  const u = trimmed(image?.url);
  return Boolean(
    u
    && !u.startsWith('data:')
    && !u.startsWith('blob:')
    && !u.startsWith('indexeddb://'),
  );
}

/**
 * 图片空间卡片/弹窗/选图：解析展示用 raw URL。
 * @param {object} image
 * @param {Record<string, string>} [urlMap] IndexedDB 预加载等
 */
export function resolveImageSpaceDisplayRawUrl(image, urlMap = {}) {
  if (!image || typeof image !== 'object') return '';

  const id = image.id != null ? String(image.id) : '';
  if (id) {
    const mapped = trimmed(urlMap[id]);
    if (mapped) return mapped;
  }

  if (hasImageSpacePersistedUrl(image)) {
    return trimmed(image.url);
  }

  // 入库回包偶发仅有签名展示地址时仍可出图（避免「图片地址缺失」）
  const signed = trimmed(image.viewUrl) || trimmed(image.displayUrl);
  if (signed) return signed;

  const src = trimmed(image.src);
  if (src && !src.startsWith('indexeddb://')) {
    if (isInlineImagePreviewUrl(src)) return src;
    if (!trimmed(image.url)) return src;
  }

  const dataUrl = trimmed(image.dataUrl);
  if (isInlineImagePreviewUrl(dataUrl)) return dataUrl;

  return trimmed(image.url) || src || dataUrl;
}

/** 入库未完成：仅有 data/blob 预览、尚无受管 url */
export function isImageSpaceIngestPending(image, rawUrl) {
  if (hasImageSpacePersistedUrl(image)) return false;
  const u = trimmed(rawUrl);
  return isInlineImagePreviewUrl(u);
}
